export default "__VITE_ASSET__21734c58__"